import * as actions from "./actions"
import { state } from "./state"
import { createStateHook, createActionsHook } from "overmind-react"

export const config = {
	state,
	actions,
}

export const useAppState = createStateHook(config)
export const useAppActions = createActionsHook(config)
